module.exports = __webpack_public_path__ + "static/media/lofi.cdf2d10a.mp3";